/* eslint-disable
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {Model, ViewOptions} from 'backbone';
import * as d3 from 'd3';
import $ from 'jquery';

import * as selectioncontextmenu from 'components/SelectionContextMenu';
import {MenuChoicesOptions} from 'components/SelectionContextMenuHelpers';
import {Sequence} from 'components/Sequence';
import {LayeringMode} from 'constants/MapsConstants';
import {Strand} from 'constants/MolbioConstants';
import Protein from 'molbio/aa-sequences/AaSequence';
import {
  AnnotationRenderParams,
  getAnnotationLabelData,
  getAnnotationPathParams,
} from 'molbio/maps/linear/AnnotationsHelpers';
import LayeredView, {LayeredViewOptions} from 'molbio/maps/linear/LayeredView';
import {Annotations, LinearLayout} from 'molbio/maps/linear/LinearLayout';
import Slice from 'molbio/maps/linear/Slice';
import {RegionSelectable} from 'molbio/maps/selectables/Selectables';
import Type from 'molbio/maps/Type';
import {TabState} from 'Navigation';
import {VisibilityOption} from 'settings/visibility-options/VisibilityOptions';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import {Optional} from 'util/Types';

export interface PolymerAnnotationsViewModelAttrs<Polymer extends Sequence | Protein> {
  sequence: Polymer;
  layout: LinearLayout;
  layeringMode: LayeringMode;
  inlineLabelPadding: number;
}

export interface PolymerAnnotationsViewModel<Polymer extends Sequence | Protein> extends Model {
  get<K extends keyof PolymerAnnotationsViewModelAttrs<Polymer>>(
    key: K
  ): PolymerAnnotationsViewModelAttrs<Polymer>[K];
  protein(): Protein;
  polymer(): Polymer;
  inlineAnnotationLabelPlacement?(model: Model, slice: Slice): string;
}

// Minimal type an annotation-like object must satisfy for the data needed by this view.
export type PolymerAnnotationsViewData<Polymer extends Sequence | Protein> = RegionSelectable<Polymer> & {
  name(): string;
  color(): string;
  strand(): Strand;
  click(polymer: Polymer, shiftKey: Optional<boolean>): void;
  dblClick(polymer: Polymer, shiftKey: Optional<boolean>): void;
};

export interface PolymerAnnotationsOptions extends LayeredViewOptions {
  mapType: string;
}

class PolymerAnnotationsView<
  Polymer extends Sequence | Protein,
  TModel extends PolymerAnnotationsViewModel<Polymer>,
  TFeature extends PolymerAnnotationsViewData<Polymer>,
> extends LayeredView<Polymer, TFeature> {
  override className!: string;
  // VisibilityOption setting name
  override setting!: string;
  override option!: VisibilityOption;
  override model!: TModel;
  tabstate!: TabState;
  mapType!: string;
  layout!: Annotations;
  override slice!: Slice;

  static override initClass(): void {
    this.prototype.className = 'annotations';
    this.prototype.setting = vo.ANNOTATIONS.name;
  }

  override hideHandler(): void {
    if (!this.isShown()) {
      this.model.set({visibleA: 0, shownA: 0});
    }
  }

  override getLayout(): Annotations {
    return this.model.get('layout').Annotations;
  }

  override layeringMode(): LayeringMode {
    return this.model.get('layeringMode');
  }

  override isShown(): boolean {
    return this.shouldShow();
  }

  override contextMenuOptions(): Array<string> {
    return selectioncontextmenu.ANNOTATION_MENU;
  }

  override contextMenuData(d: TFeature): MenuChoicesOptions {
    // TODO: MenuChoicesOptions currently expects a sequence annotation, but we might have a
    // protein annotation here. Currently, we cast to appease the typechecker, but ideally we'd
    // fix the types more holistically.
    // @ts-expect-error
    return {annotation: d, feature: d, alignment: this.mapType === 'alignment'};
  }

  override initialize(options: ViewOptions<TModel> & PolymerAnnotationsOptions): void {
    super.initialize(options);
    this.tabstate = options.tabstate;
    this.mapType = options.mapType;
    this.layout = this.model.get('layout').Annotations;
  }

  override registerListeners(): void {
    super.registerListeners();
    this._registerAnnotationListeners();
  }

  _registerAnnotationListeners(): void {
    throw new Error('Method not implemented');
  }

  override clickAction(e: Event, d: TFeature): void {
    d.click(this.model.polymer(), (e as MouseEvent).shiftKey);
  }

  override dblClickAction(e: Event, d: TFeature): void {
    d.dblClick(this.model.polymer(), (e as MouseEvent).shiftKey);
  }

  makeLayerPiece(enter: d3.Selection<SVGElement, TFeature, SVGGElement, unknown>): void {
    // Call on an enter selector.
    enter.attr('data-test-component', 'annotationsView');
    enter.attr('data-test-element', 'root');
    enter.append('svg:path').classed('layer-fill', true);
    enter.append('svg:path').classed('left-side', true).classed('stroked', true);
    enter.append('svg:path').classed('right-side', true).classed('stroked', true);
    enter.append('svg:path').classed('middle-side', true).classed('stroked', true);
    enter.append('svg:path').classed('leftside-arrows', true).classed('stroked', true);
    enter.append('svg:path').classed('rightside-arrows', true).classed('stroked', true);
    enter.each(function (d: TFeature): JQuery {
      return $(this).tooltip({
        delay: 100,
        trigger: 'hover',
        placement: 'top',
        container: 'body',
      });
    });
  }

  getResiduesType(): Type {
    return this.model.get('layout').DNA.get('type');
  }

  _addAnnotationBorder(el: Element, params: AnnotationRenderParams): void {
    d3.select(el)
      .selectAll('path.stroked')
      .attr('stroke', (d: TFeature) => {
        if (d.selected()) {
          return '#111';
        } else {
          return d3.rgb(params.color).darker().formatHex();
        }
      })
      .attr('stroke-opacity', 0.7)
      .attr('fill', 'none');
  }

  _tooltipText(name: string | null, outOfSync: boolean): string | null {
    const outOfSyncMessage = 'This part does not match the containing sequence';
    if (outOfSync) {
      return name == null ? outOfSyncMessage : `${name}\n${outOfSyncMessage}`;
    } else {
      return name;
    }
  }

  _addAnnotationLabels(el: Element, d: TFeature, params: AnnotationRenderParams): void {
    const labelPlacement = this.model.inlineAnnotationLabelPlacement?.(d, this.slice);

    const {displayName, labelData, spaceInside, inside} = getAnnotationLabelData(
      params,
      this.getLayout().get('type'),
      this.getResiduesType(),
      d.name(),
      d.strand(),
      this.layeringMode(),
      this.slice.get('visibleWidth')!,
      this.slice.get('leftBP'),
      this.slice.get('rightBP'),
      this.model.get('inlineLabelPadding'),
      labelPlacement
    );

    if (!spaceInside) {
      $(el).attr('data-original-title', this._tooltipText(d.name(), Boolean(params.outOfSync)));
    } else {
      $(el).attr('data-original-title', this._tooltipText(null, Boolean(params.outOfSync)));
    }

    const labels = d3.select(el).selectAll('text').data(labelData);

    labels
      .join('svg:text')
      .attr('x', (d) => d)
      .attr('y', this.getLayout().get('single').height() - 2)
      .attr('font-size', this.getLayout().get('type').fontSize)
      .attr('fill', inside ? params.labelColor : params.outsideLabelColor)
      .text(displayName);
  }

  _drawAnnotation(el: Element, d: TFeature, params: AnnotationRenderParams): void {
    const {
      fillD,
      strokeLeftD,
      strokeMiddleD,
      strokeRightD,
      strokeLeftRender,
      strokeRightRender,
      strokeMiddleRender,
    } = getAnnotationPathParams(params, this.slice.start(), this.slice.end(), d.strand());

    d3.select(el)
      .select('path.right-side')
      .attr('d', strokeRightD)
      .attr('shape-rendering', strokeRightRender);

    d3.select(el).select('path.left-side').attr('d', strokeLeftD).attr('shape-rendering', strokeLeftRender);

    d3.select(el)
      .select('path.middle-side')
      .attr('d', strokeMiddleD)
      .attr('shape-rendering', strokeMiddleRender);

    const calculatedOpacity = d.get('hover') || d.selected() ? 1.0 : 0.7;
    const opacity = params.forceOpacity != null ? params.forceOpacity : calculatedOpacity;
    d3.select(el)
      .select('path.layer-fill')
      .attr('d', fillD)
      .attr('fill', d3.rgb(params.color).formatHex())
      .attr('fill-opacity', opacity);
  }

  // These are the tiny double arrows inside the annotation that point out its direction if the end is out of
  // visible range.
  _addAnnotationArrows(el: Element, d: TFeature, params: AnnotationRenderParams): void {
    const {start, end, width, height, tipWidth} = params;
    let leftsideArrow, rightsideArrow;
    const arrowsOffset = 6;
    const arrowWidth = 3;
    const arrowPadding = 3;
    const arrowSpacing = 3;

    function arrowD(xoffset: number, dir: number): string {
      const endX = dir === -1 ? xoffset + arrowWidth : xoffset;
      const tipX = dir === 1 ? xoffset + arrowWidth : xoffset;
      const topY = arrowPadding + 1;
      const bottomY = height - arrowPadding;
      const middleY = height / 2;
      return `M ${endX} ${topY} L ${tipX} ${middleY} L ${endX} ${bottomY} `;
    }

    const showLeftEnd = start >= this.slice.start();
    const showRightEnd = end <= this.slice.end();

    const noOpPath = 'M 0 0 L 0 0';

    // Show arrows only next to jaggies.
    if (showLeftEnd) {
      leftsideArrow = noOpPath;
    } else {
      leftsideArrow = arrowD(arrowsOffset, d.strand()) + arrowD(arrowsOffset + arrowSpacing, d.strand());
    }

    if (showRightEnd) {
      rightsideArrow = noOpPath;
    } else {
      rightsideArrow =
        arrowD(width - arrowWidth - arrowSpacing - arrowsOffset, d.strand()) +
        arrowD(width - arrowWidth - arrowsOffset, d.strand());
    }

    const padding = arrowsOffset + arrowSpacing + arrowWidth;

    // is there room for at least one arrow?
    const noShowArrows = padding > width - tipWidth;
    // If you can see both sides, leave it alone.
    if (noShowArrows || (showRightEnd && showLeftEnd)) {
      leftsideArrow = noOpPath;
      rightsideArrow = noOpPath;
    }

    d3.select(el)
      .select('.leftside-arrows')
      .attr('d', leftsideArrow)
      .attr('shape-rendering', 'geometricPrecision');

    d3.select(el)
      .select('.rightside-arrows')
      .attr('d', rightsideArrow)
      .attr('shape-rendering', 'geometricPrecision');
  }

  rerenderSingle(el: Element, start: number, end: number, dx: number, dy: number, d: TFeature): void {
    const renderParams: AnnotationRenderParams = {
      start,
      end,
      width: dx,
      height: dy,
      // @ts-expect-error: arg to charWidth looks unused, we should remove it.
      tipWidth: Math.min(dx, this.getLayout().get('type').charWidth(1)),
      arrowsOffset: 6,
      arrowWidth: 3,
      arrowSpacing: 3,
      color: d.color(),
      labelColor: 'black',
      outsideLabelColor: 'black',
    };

    this._drawAnnotation(el, d, renderParams);
    this._addAnnotationLabels(el, d, renderParams);
    this._addAnnotationArrows(el, d, renderParams);
    this._addAnnotationBorder(el, renderParams);
  }
}
PolymerAnnotationsView.initClass();

export default PolymerAnnotationsView;
